import type {ContextValue} from '@/modules/common/context/SeaCampaign/models';

import {createContext} from 'react';

export const SeaCampaignContext = createContext<ContextValue | null>(null);
